<h2 mat-dialog-title>{{ editMode ? 'Edit' : 'Add' }} Oregon Training Program</h2>


<mat-dialog-content>
  <form [formGroup]="trainingForm">
    <div class="flex flex-col gap-4">

      <mat-form-field>
        <mat-label>Training Program Name </mat-label>
        <mat-select formControlName="programId" required>
          <mat-option *ngFor="let program of trainingPrograms" [value]="program.programId">
            {{ program.programId }} - {{ program.programName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="trainingForm.get('programId').hasError('required')">
          Training Program Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="sharedService.isAfterJan15th2027()">
        <mat-label>Practicum Site Supervisor Worker Permit Number</mat-label>
        <input matInput formControlName="workerPermitNumber" placeholder="Worker permit number">
        <mat-error *ngIf="trainingForm.get('workerPermitNumber').hasError('required')">
          Practicum Site Supervisor Worker Permit Number is required
        </mat-error>
        <mat-error *ngIf="trainingForm.get('workerPermitNumber').hasError('permitNotFound')">
          This is not an approved worker permit number
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Practicum Site Supervisor</mat-label>
        <input matInput formControlName="supervisor" placeholder="Enter supervisor name">
        <mat-error *ngIf="trainingForm.get('supervisor').hasError('required')">
          Practicum Site Supervisor is required
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Practicum Site Supervisor is from</mat-label>
        <mat-select formControlName="supervisorFrom" required>
          <mat-option value="Training Program">Training Program</mat-option>
          <mat-option value="Service Center">Service Center</mat-option>
        </mat-select>
        <mat-error *ngIf="trainingForm.get('supervisorFrom').hasError('required')">
          Practicum Site Supervisor is From is required
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!trainingForm.valid" (click)="onSave()">Save</button>
</mat-dialog-actions>
